import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Layout } from "./features/layout/Layout";
import Top from "./features/Top/Top";
import Generated from "./features/Generated/Generated";
import Comprete from "./features/Comprete/Comprete";

const RouterConfig = () => {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route index element={<Top />} />
            <Route path="generated" element={<Generated />} />
            <Route path="comprete" element={<Comprete />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </>
  );
};

export default RouterConfig;
